import React from 'react'
import { Box, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { PRIMARY_BUTTON } from 'themes/theme'
import Button from 'components/Common/Button'
import ZendeskLink from 'components/Common/ZendeskLink'

const sx = {
  header: {
    h6: {
      color: '#0A78CD',
    },
  },
  btn: {
    margin: '25px 0px',
  },
  zen: {
    position: 'absolute',
    textAlign: 'center',
    bottom: '25px',
    left: '50%',
  },
}
const UpgradeBusiness = () => {
  const navigate = useNavigate()
  return (
    <Box>
      <Box sx={sx.header}>
        <Typography variant="h6">Become a premium member to add beneficial owners.</Typography>
      </Box>
      <Box sx={sx.btn}>
        <Button type={PRIMARY_BUTTON} onClick={() => navigate('/welcome')}>
          Upgrade
        </Button>
      </Box>
      <Box sx={sx.zen}>
        <ZendeskLink />
      </Box>
    </Box>
  )
}

export default UpgradeBusiness
